export default {
  computed: {
    getLang: function() {
      if (this.$route.query.lang !== undefined) return this.$route.query.lang;
      else return "fr";
    },
  },
};
